module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    staticClass: "cardDetails"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: ("url('" + _vm.image + "')")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "cardText"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('ul', _vm._l((_vm.list), function(item) {
    return _c('li', [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "button",
    attrs: {
      "label": _vm.buttonText
    },
    on: {
      "click": function($event) {
        return _vm.goToArticle(_vm.buttonLink)
      }
    }
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "info-circle"
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f13dc906","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CoachingCard/CoachingCard.vue
// module id = 3314
// module chunks = 1